export default "__VITE_PUBLIC_ASSET__325386f5__"